var $detailProduktu = { parametry: {} };
//var $kosik = {};
//var $provestNakup = false;
//var $ajaxCartItem = false;

import { Top } from "../class/Top.js";
import { Kosik } from "../class/Kosik.js";
import { KonfiguraceZbrane as KF } from "../class/KonfiguraceZbrane.js";

function ziskaniUdajuProduktu() {
  $detailProduktu.mena = "CZK";
  if (
    $("button#topNavigationDropdown")
      .text()
      .trim() == "EUR"
  )
    $detailProduktu.mena = "EUR";

  $detailProduktu.cena_format = $("form#product-detail-form .price-final")
    .text()
    .trim();
  var $c = $("form#product-detail-form .price-final .default-variant");
  if ($c.length) $detailProduktu.cena_format = $c.text().trim();

  $detailProduktu.cena = $detailProduktu.cena_format.prevedNaCislo();
  $detailProduktu.cena_bezDHP_zaokrouhlenaFormat =
    Number($detailProduktu.cena_bezDHP).formatMoney(0, ",", " ") + " Kč";

  $detailProduktu.cena_bezDHP_format = $(
    "form#product-detail-form .price-additional"
  )
    .text()
    .trim();
  $detailProduktu.cena_bezDHP1 = $detailProduktu.cena_bezDHP_format
    .replace("bez DPH", "")
    .trim();

  $detailProduktu.priceStandard = "";

  $c = $("form#product-detail-form .p-final-price-wrapper .price-standard");
  if ($c.length) $detailProduktu.priceStandard = $c.text().trim();

  $detailProduktu.cena_bezDHP = $detailProduktu.cena_bezDHP_format.prevedNaCislo();
  $detailProduktu.cena_bezDHP_zaokrouhlenaFormat =
    Number($detailProduktu.cena_bezDHP).formatMoney(0, ",", " ") + " Kč";

  $detailProduktu.beznaCena_format = $(
    "form#product-detail-form .p-info-wrapper .price-standard span"
  )
    .text()
    .trim();
  $detailProduktu.sleva = $(
    "form#product-detail-form .p-info-wrapper .price-save"
  )
    .text()
    .trim();
  $detailProduktu.kodProduktu = $(".p-detail-inner-header .p-code-label")
    .next("span")
    .text()
    .trim();
  $detailProduktu.dostupnost = $("form#product-detail-form .availability-label")
    .wrap("<div></div>")
    .parent(); //.get(0);
  $detailProduktu.muzemeDorucit = $("form#product-detail-form .delivery-time")
    .text()
    .trim();

  var $aVyrobce = $('.p-detail-info a[href^="/znacka/"]');
  $detailProduktu.Vyrobce = false;
  if ($aVyrobce.length) {
    $detailProduktu.Vyrobce = {
      url: $aVyrobce.attr("href"),
      text: $aVyrobce.text().trim()
    };
  }
} //function ziskaniUdajuProduktu()

function vratVyrobce() {
  var $c = $detailProduktu.Vyrobce;
  if (typeof $c == "undefined") return "";

  if (!$c) return "";

  var $v = window.vyrobce[$c.text];

  var $img = "";
  if (typeof $v == "undefined") {
    $img = "<strong>" + $c.text + "</strong>";
  } else {
    $img =
      '<img src="' + $shoptetUpload + window.ruzne.cestaVyrobci + $v + '?v3">';
  }

  return (
    '<span class="vyrobce"><a href="' + $c.url + '">' + $img + "</a></span>"
  );
} //function vratStavZbozi()

function nactiUpravParametry() {
  var $tabulkaParametru = $("div#description table.detail-parameters");
  if (!$tabulkaParametru.length) return;

  $tabulkaParametru.prev("h3").text("Specifikace");

  $tabulkaParametru.find("tr").each(function() {
    var parametr = $(this)
      .find("th")
      .text()
      .trim()
      .slice(0, -1);
    var hodnota = $(this)
      .find("td")
      .text()
      .trim();

    if (parametr == "Druh zboží") {
      $detailProduktu.parametry["DruhZbozi_url"] = $(this)
        .find("td a")
        .attr("href");
    }

    $detailProduktu.parametry[parametr] = hodnota;
  });
} //function nactiParametry()

function ulozProdukty() {
  //-----ulozeni naposledy navstivenych produktu
  var $obr, $attr;
  var $cestaObrMobil = $(
    "form#product-detail-form .p-image a.p-main-image img"
  );
  if ($("div#wrap img").length) {
    $attr = $("div#wrap img").attr("data-src");
    if ($attr)
      $obr = $("div#wrap img")
        .attr("data-src")
        .replace("/big/", "/detail/");

    $attr = $("div#wrap img").attr("src");
    if ($attr)
      $obr = $("div#wrap img")
        .attr("src")
        .replace("/big/", "/detail/");
  } else if ($cestaObrMobil.length) {
    $attr = $cestaObrMobil.attr("data-src");
    if ($attr)
      $obr = $cestaObrMobil.attr("data-src").replace("/big/", "/detail/");

    $attr = $cestaObrMobil.attr("src");
    if ($attr) $obr = $cestaObrMobil.attr("src").replace("/big/", "/detail/");
  } else {
    $obr = "/cms/img/missing_images/detail.png";
  }

  Lc.h("detail");

  Lc.log("obr", $obr);

  var $dostupnost = $detailProduktu.dostupnost.html();
  var $c = $helper.get("shoptet.product");
  if ($c.hasVariants) {
    $dostupnost = $(
      'form#product-detail-form .availability-label:contains("Skladem"):first'
    )
      .parent()
      .html(); //.get(0);
    if (typeof $dostupnost == "undefined") {
      $dostupnost = $(
        'form#product-detail-form .availability-label:not(:contains("Skladem")):first'
      )
        .parent()
        .html(); //.get(0);
    }
  }

  var $objekt = {
    url: window.location.pathname,
    nazev: $("div.p-detail-inner-header H1")
      .text()
      .trim(),
    obr: $obr,
    cena: $detailProduktu.cena_format,
    puvodni: $detailProduktu.priceStandard,
    dostupnost: $dostupnost,
    kod: $detailProduktu.kodProduktu
  };
  $.fn.ladzoNavstivene("ulozProdukty", $objekt, 4);
}

function det_pravaCastDetailu() {
  var $kod =
    '<div class="dvStitky"></div><!-- class="dvStitky"--> \
    <div class="cnt c1"> \
        <div class="leva">  \
            <div class="dvNadpis"></div><!-- class="dvNadpis"--> \
            <div class="dvID"></div><!-- class="dvID"-->   \
        </div><!-- class="leva"-->    \
        <div class="prava">  \
            <div class="dvZn"></div><!-- class="dvZn"--> \
        </div><!-- class="prava"-->    \
    </div><!-- class="cnt c1"-->  \
    <div class="cnt c2"> \
        <div class="leva">  \
            <strong class="str1">Cena</strong>  \
            <span class="dvCena"></span><!-- class="dvCena"--> \
            <span class="dvCenaBezDPH"></span><!-- class="dvCenaBezDPH"-->   \
        </div><!-- class="leva"-->    \
        <div class="prava">  \
            <div class="dvDostup"></div><!-- class="dvDostup"--> \
        </div><!-- class="prava"-->    \
    </div><!-- class="cnt c2"-->  \
    <div class="cnt c3"> \
        <div class="leva">  \
            <strong class="str1">Zvolte si variantu:</strong>  \
        </div><!-- class="leva"-->    \
        <div class="prava">  \
        </div><!-- class="prava"-->    \
    </div><!-- class="cnt c3"-->  \
    <a class="aTabV" target="_blank" href="/tabulka-velikosti/">Tabulka velikostí</a>  \
    <div class="cnt c4"> \
        <div class="leva">  \
        </div><!-- class="leva"-->    \
        <div class="prava">  \
        </div><!-- class="prava"-->    \
    </div><!-- class="cnt c4"-->';

  return $kod;
} //function  det_pravaCastDetailu()

function det_pravaCastDetailuDoplnUdaje() {
  $("#dvInfo").each(function() {
    var $this = $(this);
    var $form = $("form#product-detail-form");

    $(".p-detail-info .flags").appendTo($this.find(".dvStitky"));

    $(".p-detail-inner h1").appendTo($this.find(".cnt.c1 .dvNadpis"));
    $(".p-detail-inner-header .p-code").appendTo($this.find(".cnt.c1 .dvID"));

    $this.find(".p-code-label").text("ID: ");

    var $fce = vratVyrobce();
    if ($fce.length) $this.find(".cnt.c1 .dvZn").html($fce);

    $form.find(".price-final").prependTo($this.find(".cnt.c2 .dvCena"));
    $form
      .find(".price-additional")
      .prependTo($this.find(".cnt.c2 .dvCenaBezDPH"));

    $form
      .find(".availability-value")
      .prependTo($this.find(".cnt.c2 .dvDostup"));
    $(".dvDostup .availability-label").each(function() {
      $(this).prepend('<span class="tit">Dostupnost: </tit>');
    });

    var $hasVariants = $helper.get("shoptet.product.hasVariants");
    if ($hasVariants) {
      $form
        .find("table.detail-parameters")
        .appendTo($this.find(".cnt.c3 .prava"));
    } else {
      $this.find(".cnt.c3").remove();
      $this.find("a.aTabV").remove();
    }

    $form
      .find(".social-buttons-wrapper")
      .prependTo($this.find(".cnt.c4 .leva"));
    $form.find(".add-to-cart").prependTo($this.find(".cnt.c4 .prava"));
  });
} //function  det_pravaCastDetailuDoplnUdaje()

function det_presunPodobne() {
  //return false;
  $("#productsAlternative").each(function() {
    $('#p-detail-tabs li a[href="#productsAlternative"]')
      .parent()
      .hide();

    var $kod =
      '<div id="dvPodob"><h2>MOHLO BY SE VÁM LÍBÍT</h2><div class="cnt">';

    $(this)
      .find(".products > .product")
      .each(function() {
        //var $href=$(this).find('a.image').attr('href');
        //var $img='';
        var $a;
        $(this)
          .find("a.image")
          .each(function() {
            $(this)
              .find("img")
              .attr(
                "src",
                $(this)
                  .find("img")
                  .attr("data-src")
              );

            $(this)
              .find(".flags")
              .remove();
            $(this).append('<span class="spnDet">DETAIL</span>');

            $a = $(this)
              .wrap("<div/>")
              .parent()
              .html();
          });

        //$kod+='<a href="'+$href+'">'+$img+'</a>';
        $kod += $a;
      });

    $kod += "</div></div>";
    $($kod).insertAfter("#dvInfo");
    $(this).remove();
  });
} //function  det_presunPodobne()

export function upravDetailProduktuStranku() {
  Lc.f("upravDetailProduktuStranku");

  ziskaniUdajuProduktu();
  nactiUpravParametry();

  Kosik.loadEventForAddItemToCart();

  if (Top.jeIframe) {
    //---vsechny odkazy musi byt v iframe
    /*
        $('a').each(function(index) {

             var $href= $(this).attr('href');
             $(this).attr('href',$href + '#iframe');

        });
        */
    //----

    Lc.c("shoptet.config.showAdvancedOrder=undefined");
    shoptet.config.showAdvancedOrder = undefined;

    //----parametry nebudou mit odkazy
    $("#description table.detail-parameters td").each(function() {
      let $td = $(this);
      if ($td.find("a").length) {
        $td.html($td.find("a").text());
      }
    });

    var $kod =
      '<div id="dvPanelFrame"> \
                    <a target="_parent" onClick="history.back()">zpět k produktům</a> \
                    <span class="divider"></span>  \
                     <a class="close" href="">ZAVŘÍT NÁHLED</a> \
                    </div>';
    $($kod).appendTo("#content-wrapper");

    $("#dvPanelFrame a.close").click(function(e) {
      e.preventDefault(e);
      window.parent.$.fancybox.close();
    });

    //vybrani spravne varianty
    var $hasVariants = $helper.get("shoptet.product.hasVariants");
    if ($hasVariants) {
      Lc.f("vyber varinaty");
      Lc.log("Kf", KF.vybrano);
      let optVal;
      Lc.log("KF.Provedeni == Leve", KF.vybrano.Provedeni == "Leve");
      if (KF.vybrano.Provedeni == "Leve") {
        optVal = $('select#parameter-id-38 option:contains("levé")').val();
      } else {
        optVal = $('select#parameter-id-38 option:contains("pravé")').val();
      }
      if (optVal) $("select#parameter-id-38").val(optVal);
    }
  } //if (Top.jeIframe) {

  ulozProdukty();

  var $fce = det_pravaCastDetailu();
  if ($fce.length) {
    $('<div id="dvInfo">' + $fce + '</div><!--id="dvInfo" -->').prependTo(
      "form#product-detail-form .p-info-wrapper"
    );
    det_pravaCastDetailuDoplnUdaje();
  }

  //---presun podobnych
  det_presunPodobne();

  //--uprava obrazkz
  $(".p-image-wrapper #wrap a img").each(function() {
    var $src = $(this)
      .attr("src")
      .replace("/big/", "/orig/");
    $(this).attr("src", $src);

    $(this)
      .parent()
      .removeAttr("href");
  });

  $(".p-image-wrapper .p-thumbnails-inner a.p-thumbnail").each(function() {
    var $href = $(this)
      .attr("href")
      .replace("/big/", "/orig/");
    $(this).attr("href", $href);
  });
  //---uprava popisku
  $(".p-detail-tabs-wrapper").each(function() {
    $(this)
      .find(".basic-description > h3:first")
      .text("Popis produktu")
      .changeElementType("h2");
  });
  /*
    document.addEventListener('ShoptetCartAddCartItem', function() {
           Lc.log('---pridan produkt');
           Lc.log($('form').serialize());
    });
    */
} //export function upravaDetailuProduktu()

export { $detailProduktu as DetailProduktu };
